module.exports = __webpack_public_path__ + "static/img/szdyfsyy.e02d14b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/szdyfsyy.png
// module id = fA82
// module chunks = 0